import { render, staticRenderFns } from "./PaymentSelectionView.vue?vue&type=template&id=5f09b3a5&scoped=true&"
import script from "./PaymentSelectionView.vue?vue&type=script&lang=ts&"
export * from "./PaymentSelectionView.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentSelectionView.vue?vue&type=style&index=0&id=5f09b3a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f09b3a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f09b3a5')) {
      api.createRecord('5f09b3a5', component.options)
    } else {
      api.reload('5f09b3a5', component.options)
    }
    module.hot.accept("./PaymentSelectionView.vue?vue&type=template&id=5f09b3a5&scoped=true&", function () {
      api.rerender('5f09b3a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PaymentSelectionView.vue"
export default component.exports